import ForestDataMap from "./map/ForestDataMap";
import Header from "./components/header/Header";
import DatasetCards from "./components/DatasetCard";
import RegionalResourceKitBrowse from "./data/RegionalResourceKitBrowse";
import {useEffect, useState, useMemo} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import WorkspaceContext from './WorkspaceContext';
import {UserContext} from './UserContext';
import Home from './home';
import Verify_Account from "./verify_account";
import DataCatalog from "./data/DataCatalog";

function App() {

    const [display, setDisplay] = useState('map');
    const [category, setCategory] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [defaultKeys, setDefaultKeys] = useState([]);
    const [valueRanges, setValueRanges] = useState({})
    const [checkedDatasets, setCheckedDatasets] = useState({})
    const [filtersDatasets, setFilterDatasets] = useState({})
    const [filterItems, setFilterItems] = useState({})
    const [opacities, setOpacities] = useState({})

    // "creation_method": 
    const [regionReq, setRegionReq] = useState('Southern California');
    const [selectedDatasets, setSelectedDatasets] = useState([
    //   {
    //       "title": "Housing Burden Percentile",
    //       "type": "h3",
    //       "tier": "1",
    //       "data_vintage": "2021",
    //       "metric_definition_and_relevance": "Housing-Burdened Low-Income Households. Percent of households in a census tract that are both low income (making less than 80% of the HUD Area Median Family Income) and severely burdened by housing costs (paying greater than 50% of their income to housing costs). (5-year estimates, 2013-2017).<p>The cost and availability of housing is an important determinant of well-being. Households with lower incomes may spend a larger proportion of their income on housing. The inability of households to afford necessary non-housing goods after paying for shelter is known as housing-induced poverty. California has very high housing costs relative to much of the country, making it difficult for many to afford adequate housing. Within California, the cost of living varies significantly and is largely dependent on housing cost, availability, and demand.</p><p>Areas where low-income households may be stressed by high housing costs can be identified through the Housing and Urban Development (HUD) Comprehensive Housing Affordability Strategy (CHAS) data. We measure households earning less than 80% of HUD Area Median Family Income by county and paying greater than 50% of their income to housing costs. The indicator takes into account the regional cost of living for both homeowners and renters, and factors in the cost of utilities. CHAS data are calculated from US Census Bureau\u2019s American Community Survey (ACS).</p>",
    //       "data_resolution": "30m Raster",
    //       "data_units": "Percent",
    //       "creation_method": "CalEnviroScreen, Version 4.0, is a science-based method for identifying impacted communities by taking into consideration pollution exposure and its effects, as well as health and socioeconomic status, at the census-tract level.<strong> </strong>CalEnviroScreen 4.0 uses the census tract as the unit of analysis. Census tract boundaries are available from the Census Bureau. CalEnviroScreen uses the Bureau\u2019s 2010 boundaries. New boundaries will be drawn by the Census Bureau as part of the 2020 Census but will not be available until 2022. OEHHA will address updates to census tract geography in CalEnviroScreen at that time. There are approximately 8,000 census tracts in California, representing a relatively fine scale of analysis. Census tracts are made up of multiple census blocks, which are the smallest geographic unit for which population data are available. Some census blocks have no people residing in them (unpopulated blocks).<p>The CalEnviroScreen model is based on the CalEPA working definition in that:</p><ul><li>The model is place-based and provides information for the entire State of California on a geographic basis. The geographic scale selected is intended to be useful for a wide range of decisions.</li><li>The model is made up of multiple components cited in the above definition as contributors to cumulative impacts.</li><li>The model includes two components representing Pollution Burden \u2013 Exposures and Environmental Effects</li><li>The model includes two components representing Population Characteristics \u2013 Sensitive Populations (e.g., in terms of health status and age) and Socioeconomic Factors.</li></ul><p>The American Community Survey (ACS) is an ongoing survey of the US population conducted by the US Census Bureau and has replaced the long form of the decennial census. Unlike the decennial census, which attempts to survey the entire population and collects a limited amount of information, the ACS releases results annually based on a sub-sample of the population and includes more detailed information on socioeconomic factors. Multiple years of data are pooled together to provide more reliable estimates for geographic areas with small population sizes. Each year, the HUD receives custom tabulations of ACS data from the US Census Bureau. These data, known as the &quot;CHAS&quot; data (Comprehensive Housing Affordability Strategy), demonstrate the extent of housing problems and housing needs, particularly for low-income households. The most recent results available at the census tract scale are the 5-year estimates for 2013-2017. The data are available from the HUD user website (see page 174 in the document link below:</p><p><a href=\"https://oehha.ca.gov/media/downloads/calenviroscreen/report/calenviroscreen40reportf2021.pdf\">https://oehha.ca.gov/media/downloads/calenviroscreen/report/calenviroscreen40reportf2021.pdf</a></p>",
    //       "data_source": "California Environmental Protection Agency, CalEnviroScreen 4.0\n\n",
    //       "file_name": "HousingBurdenPctl.tif",
    //       "leading_paragraphs": "",
    //       "category": "/Social and Cultural Well-Being/Environmental Justice",
    //       "updated_data_source": "California Environmental Protection Agency, CalEnviroScreen 4.0\n--Office of Environmental Health Hazard Assessment, CAL EPA \n\n",
    //       "mapping": [
    //           {
    //               "name": "Housing Burden Percentile",
    //               "type": "raster",
    //               "url": "https://sparcal.sdsc.edu/geoserver/rrk_sc/wms",
    //               "layer": "rrk_sc:HousingBurdenPctl",
    //               "min": 0,
    //               "max": 100,
    //               "start_color": "#FFC0CB",
    //               "end_color": "#D90026"
    //           }
    //       ],
    //       "folder": "/Regional Resource Kit/Southern California",
    //       "report": {
    //           "section": "Assessing Housing Burden Percentile for Low-Income Households",
    //           "description": "This section of the data report focuses on the dataset named \"Housing Burden Percentile,\" meticulously extracted from the renowned Regional Resource Kit and thoughtfully applied to our region. The dataset offers crucial insights into the burden faced by low-income households in meeting housing costs within the census tracts. A household is considered \"low income\" if its income is less than 80% of the Housing and Urban Development (HUD) Area Median Family Income. Moreover, the dataset identifies households that are severely burdened by housing costs, defined as those paying more than 50% of their income toward housing expenses. As housing affordability and availability significantly impact overall well-being, understanding the housing-induced poverty is of utmost importance. California, in particular, faces substantial challenges in providing affordable housing due to high housing costs across the state. This section employs the Housing and Urban Development (HUD) Comprehensive Housing Affordability Strategy (CHAS) data, derived from the US Census Bureau's American Community Survey (ACS) over a 5-year period (2013-2017), to measure the stress experienced by low-income households due to exorbitant housing expenses. By shedding light on the housing burden percentile, this analysis aims to inform policies and strategies to address housing affordability and enhance the well-being of low-income households in our region."
    //       }
    //   },
    //   {
    //       "title": "Canopy Veg Cover",
    //       "type": "h3",
    //       "tier": "1",
    //       "data_vintage": "Summer 2020",
    //       "metric_definition_and_relevance": "This layer represents horizontal cover fraction occupied by tree canopies. Maps community type &amp; fire regime, as well as available habitat for tree-dwelling species.",
    //       "data_resolution": "10m Raster",
    //       "data_units": "percent | Min: 0 | Max: 100",
    //       "creation_method": "Each forest structure metric was derived directly from airborne lidar data, hosted by the USGS 3D Elevation Program. However, these data are only available for a small fraction of California\u2019s 423,970 km\u00b2 area. To overcome this, we trained deep learning models\u2014a form of pattern recognition\u2014to identify these forest structure patterns in satellite imagery, then mapped each metric statewide. <p>These algorithms are of the U-net family of neural network architectures that perform pixel-wise regression and classification tasks. The satellite data includes imagery from Sentinel-1 C-band radar sensors and Sentinel-2 multispectral sensors at 10 m spatial resolution, collected in Fall 2019. Future versions will include imagery from PlanetScope multispectral sensors at 3 m resolution.</p><p>Downloaded from <a href=\"https://wifire-data.sdsc.edu/organization/california-forest-observatory\">California Forest Observatory - Organizations - WIFIRE Commons Data Catalog (sdsc.edu)</a>. For more information, go to <a href=\"https://forestobservatory.com/about.html#about\">https://forestobservatory.com/about.html#about</a></p>",
    //       "data_source": "California Forest Observatory (Salo Sciences), 2020\n\n",
    //       "file_name": "CFO_CanopyCover2020Summer.tif",
    //       "leading_paragraphs": "",
    //       "category": "/Forest and Shrubland Resilience/Structure",
    //       "updated_data_source": "California Forest Observatory (Salo Sciences), 2020\n--Courtesy of the California Forest Observatory (forestobservatory.com), \u00a9 Salo Sciences, Inc. 2020\n\n",
    //       "mapping": [
    //           {
    //               "name": "Canopy Veg Cover",
    //               "type": "raster",
    //               "url": "https://sparcal.sdsc.edu/geoserver/rrk_sc/wms",
    //               "layer": "rrk_sc:CFO_CanopyCover2020Summer",
    //               "min": 0,
    //               "max": 100,
    //               "start_color": "#CCCCFF",
    //               "end_color": "#0000B8"
    //           }
    //       ],
    //       "folder": "/Regional Resource Kit/Southern California",
    //       "report": {
    //           "section": "Mapping Canopy Vegetation Cover and Its Ecological Implications",
    //           "description": "This section of the data report delves into the dataset titled \"Canopy Veg Cover,\" thoughtfully extracted from the renowned Regional Resource Kit and skillfully applied to our region. The dataset encapsulates vital information about the horizontal cover fraction occupied by tree canopies, offering valuable insights into the distribution of community types and fire regimes. Additionally, it serves as a key indicator of the available habitat for various tree-dwelling species, highlighting the ecological significance and biodiversity of the region's forested landscapes. By meticulously examining the canopy vegetation cover, we aim to elucidate the spatial patterns and variations in tree canopies across our study area. This detailed analysis will play a pivotal role in understanding the composition and distribution of vegetation, assessing the health and resilience of ecosystems, and identifying critical habitats for wildlife species that depend on tree canopies for their survival and sustenance. Through a comprehensive exploration of the Canopy Veg Cover dataset, we seek to uncover essential relationships between canopy cover and ecological dynamics, ultimately contributing to informed conservation efforts and sustainable management practices that promote the well-being and preservation of our region's precious natural resources."
    //       }
    //   },
    //   {
    //       "category": "/Fire Dynamics/Functional Fire",
    //       "title": "Mean Percent FRI Departure, Since 1970",
    //       "file_name": "SoCal_meanPFRID_1970.tif",
    //       "tier": "2",
    //       "data_vintage": "2021",
    //       "data_resolution": "30m Raster",
    //       "data_units": "Percent",
    //       "metric_definition_and_relevance": "Mean Percent FRID (meanPFRID_1970) quantifies the extent in percentage to which recent fires (i.e., since 1970) are burning at frequencies similar to those that occurred prior to Euro-American settlement, with the mean reference FRI as the basis for comparison. Mean PFRID measures the departure of current FRI from reference mean FRI in percent",
    //       "creation_method": "The current FRI is calculated by dividing the number of years in the fire record (e.g., 2019-1970=49 years inclusive) by the number of fires occurring between 1970 and the current year in a given polygon plus one (CurrentFRI = Number of years/Number of fires +1). The mean reference FRI is an approximation of how often, on average, a given PFR likely burned in the three or four centuries prior to significant Euro-American settlement. This measure does not return to zero when a fire occurs, unlike FRID values used in some other analyses (e.g., NPS FRID Index).",
    //       "data_source": "Fire History (2021), CAL FIRE\n\nExisting Vegetation (CALVEG 2011), USDA Forest Service, Region 5, MARS Team",
    //       "updated_data_source": "Fire History (2021), CAL FIRE\nCALFIRE, Department of Forestry and Fire Protection\n\nExisting Vegetation (CALVEG 2011), USDA Forest Service, Region 5, MARS Team\nUSDA Forest Service - Region 5 - Pacific Southwest Region ",
    //       "mapping": [
    //           {
    //               "name": "Mean Percent FRI Departure, Since 1970",
    //               "type": "raster",
    //               "url": "https://sparcal.sdsc.edu/geoserver/rrk_sc/wms",
    //               "layer": "rrk_sc:SoCal_meanPFRID_1970",
    //               "min": -99,
    //               "max": 79,
    //               "start_color": "#E3BC9A",
    //               "end_color": "#774921"
    //           }
    //       ],
    //       "folder": "/Regional Resource Kit/Southern California",
    //       "report": {
    //           "section": "Evaluating Mean Percent Fire Return Interval Departure since 1970",
    //           "description": "This section of our data report delves into the dataset named \"Mean Percent FRI Departure, Since 1970,\" which has been thoughtfully extracted from the esteemed Regional Resource Kit and meticulously applied to our region. The metric, Mean Percent FRID (meanPFRID_1970), serves as a valuable tool in quantifying the extent, expressed in percentage, to which recent fires, occurring since 1970, align with fire frequencies observed prior to Euro-American settlement. By comparing the current Fire Return Interval (FRI) to the mean reference FRI, this analysis enables us to measure the departure of current FRI from the reference mean FRI, providing crucial insights into changes in fire regimes. Understanding such departures is essential for effective fire management and decision-making, as it allows us to identify areas at risk of altered fire frequencies and potential threshold-type responses. By utilizing this metric, land managers can develop proactive strategies to protect and restore landscapes in a sustainable manner."
    //       }
    //   },
    //   {
    //       "folder": '/Interagency Tracking System',
    //       "mapping": [
    //           {
    //               'name': 'Million Acres Flat File Points',
    //               'url': 'https://sparcal.sdsc.edu/geoserver/ITS/wms',
    //               'layer': 'ITS:its_points_20230822',
    //               'type': 'vector',
    //               'max': 16724448,
    //               'min': 16409952,
    //               'color': 'rgba(159, 87, 174, 0.6)'
    //           }
    //       ]
    //   },
    //   {
    //       "folder": '/Interagency Tracking System',
    //       "mapping": [
    //           {
    //               'name': 'Million Acres Flat File Lines',
    //               'url': 'https://sparcal.sdsc.edu/geoserver/ITS/wms',
    //               'layer': 'ITS:its_lines_20230822',
    //               'type': 'vector',
    //               'max': 16724448,
    //               'min': 16409952,
    //               'color': 'rgba(159, 87, 174, 0.6)'
    //           }
    //       ]
    //   },
    //   {
    //       "folder": '/Interagency Tracking System',
    //       "mapping": [
    //           {
    //               'name': 'Million Acres Flat File Polygons',
    //               'url': 'https://sparcal.sdsc.edu/geoserver/ITS/wms',
    //               'layer': 'ITS:its_polygons_20230822',
    //               'type': 'vector',
    //               'max': 16724448,
    //               'min': 16409952,
    //               'color': 'rgba(159, 87, 174, 0.6)'
    //           }]
    //   },
    // {    
    //       "folder": '/Boundaries',
    //       "mapping": [
    //           {
    //               'name': 'California Counties',
    //               'url': 'https://sparcal.sdsc.edu/geoserver/boundary/wms',
    //               'layer': 'boundary:ca_counties',
    //               'type': 'vector'
    //           }],
    //       "report": {
    //           "main_column": 'name',
    //           "disabled": false
    //       }
    //   },{
    //       "folder": '/Boundaries',
    //       "mapping": [
    //           {
    //               'name': 'California Local Fire Districts',
    //               'url': 'https://twsa.ucsd.edu/geoserver/rrk_nv/wms',
    //               'layer': 'rrk_nv:California_Fire_Districts',
    //               'type': 'vector',
    //           }],
    //       "report": {
    //           "main_column": 'Name'
    //       }

    //   },{
    //       "folder": '/Boundaries',
    //       "mapping": [
    //           {
    //               'name': 'California Local Fire Districts',
    //               'url': 'https://twsa.ucsd.edu/geoserver/rrk_nv/wms',
    //               'layer': 'rrk_nv:california_local_fire_districts',
    //               'type': 'vector',
    //           }],
    //       "report": {
    //           "main_column": 'name',
    //           "disabled": false
    //       }

    //   },{
    //       "folder": '/Boundaries',
    //       "mapping": [
    //           {
    //               'name': 'CALFIRE Administrative Units',
    //               'url': 'https://sparcal.sdsc.edu/geoserver/boundary/wms',
    //               'layer': 'boundary:california_local_fire_districts',
    //               'type': 'vector',
    //           }],
    //       "report": {
    //           "main_column": 'UNIT',
    //           "disabled": false
    //       }
    //   },{
    //       "folder": '/Boundaries',
    //       "mapping": [
    //           {
    //               'name': 'Regional Resource Kit Boundaries',
    //               'url': 'https://sparcal.sdsc.edu/geoserver/boundary/wms',
    //               'layer': 'boundary:rrk_boundaries',
    //               'type': 'vector',
    //           }],
    //       "report": {
    //           "main_column": 'rrk_region',
    //           "disabled": false
    //       }
    //   }
  ]);

	const [user, setUser] = useState({});

	const [userStorage] = useState(() => {
		const user = sessionStorage.getItem("user");
		return JSON.parse(user) || null;
	});

	const providerValue = useMemo(() => (
		{user, setUser}), 
		[user, setUser]);

	useEffect(() => {
		if(userStorage != null){
			setUser(userStorage)
		}
	}, [userStorage]);


    const getGisService = (dataset) => {
        console.log("getGisService")
        console.log(dataset)
        return dataset.gis_services.filter(e => e.service_type === 'ArcGIS').length > 0 
                ? dataset.gis_services.filter(e => e.service_type === 'ArcGIS')[0]
                : dataset.gis_services[0]
    }

    const getItemKey = (dataset) => {
        return getGisService(dataset).service_url + '/' + getGisService(dataset).layer_name
    }

    console.log("user here here")
    console.log(user)
    console.log(user.access_token)

	// if(Object.keys(user).length === 0 || user?.username == undefined){
		return (
            <BrowserRouter>
                <Routes>
                    { 
                        Object.keys(user).length === 0 || user?.access_token == undefined
                        ?
                            <Route path="/" element={
                                <UserContext.Provider value={providerValue}>
                                    <Header display={display} setDisplay={setDisplay}/>
                                    <Home />
                                </UserContext.Provider>
                            } />
                        :  <Route path="/" element={
                            <UserContext.Provider value={providerValue}>
                                <WorkspaceContext.Provider value={{selectedDatasets, setSelectedDatasets, valueRanges, 
                                    setValueRanges, checkedDatasets, setCheckedDatasets, setRegionReq,
                                    setDefaultKeys, setSelectedKeys, defaultKeys, selectedKeys}}>
                                    <Header display={display} setDisplay={setDisplay}
                                         getGisService={getGisService}
                                         getItemKey={getItemKey}
                                         setFilterItems={setFilterItems}
                                         setCheckedDatasets={setCheckedDatasets}
                                         opacities={opacities}
                                         setOpacities={setOpacities}
                                    />
                                    <ForestDataMap display={display}
                                                setDisplay={setDisplay}
                                                selectedDatasets={selectedDatasets}
                                                setCategory={setCategory}
                                                valueRanges={valueRanges} 
                                                setValueRanges={setValueRanges}
                                                checkedDatasets={checkedDatasets}
                                                setCheckedDatasets={setCheckedDatasets}
                                                filtersDatasets={filtersDatasets}
                                                setFilterDatasets={setFilterDatasets}
                                                getGisService={getGisService}
                                                getItemKey={getItemKey}
                                                filterItems={filterItems}
                                                setFilterItems={setFilterItems}
                                                opacities={opacities}
                                                setOpacities={setOpacities}
                                    />
                                    <RegionalResourceKitBrowse display={display} setDisplay={setDisplay} category={category} regionReq={regionReq}
                                            checkedDatasets={checkedDatasets}
                                            setCheckedDatasets={setCheckedDatasets}/>
                                    <DataCatalog access_token={user.access_token} display={display} setDisplay={setDisplay}/>
                                </WorkspaceContext.Provider>
                            </UserContext.Provider>}>
                            </Route>
                    }
                    <Route path="/Auth/validate_account/:username/:access_token" exact element={<Verify_Account/>}></Route>
                </Routes>
            </BrowserRouter>
		);
}

export default App;
